import { render, staticRenderFns } from "./Stripe.vue?vue&type=template&id=971a2246"
import script from "./Stripe.vue?vue&type=script&lang=js"
export * from "./Stripe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports